import React from 'react';

import { Box, Text } from '@components/Restyle';
import theme from '@themes/theme'; // Replace with your actual UI library

interface CustomToastProps {
  message: string;
  backgroundColor?: keyof typeof theme.colors;
}

const CustomToast: React.FC<CustomToastProps> = ({
  message,
  backgroundColor = 'grey05',
}) => {
  return (
    <Box
      backgroundColor={backgroundColor}
      style={{
        padding: 10,
        borderRadius: 5,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        gap: 8,
        position: 'relative',
      }}>
      <Text variant='labelSmall' color='white'>
        {message}
      </Text>
    </Box>
  );
};

export default CustomToast;
